class VenueMap {
  constructor(address, mapId) {
    this.mapId = mapId
    this.map = null
    this.geocoder = null
    this.pendingAddress = address
    this.mapElement = document.getElementById(mapId)
    this.geocodeTimeout = null
    this.initialize()
    // Commented out to avoid duplicate listeners - the event form controller handles this
    // this.setupAddressListeners()

    // Don't check initial address state here - let the controller handle it
    // if (this.isAddressComplete()) {
    //   this.handleAddressChange()
    // }
  }

  async initialize() {
    try {
      await window.googleMapsReady
      const { Geocoder } = await google.maps.importLibrary("geocoding")
      this.geocoder = new Geocoder()

      if (this.pendingAddress) {
        this.updateAddress(this.pendingAddress)
        this.pendingAddress = null
      }
    } catch (error) {
      console.error('Error initializing VenueMap:', error)
    }
  }

  setupAddressListeners() {
    const addressFields = document.querySelectorAll('[data-address-field]')
    addressFields.forEach(field => {
      field.addEventListener('change', () => this.handleAddressChange())
    })
  }

  isAddressComplete() {
    const street = document.querySelector('[data-address-field="street"]')?.value
    const city = document.querySelector('[data-address-field="city"]')?.value
    const state = document.querySelector('[data-address-field="state"]')?.value

    return street?.length > 0 && city?.length > 0 && state?.length > 0
  }

  handleAddressChange() {
    if (!this.isAddressComplete()) {
      this.hideMap()
      return
    }

    const address = this.buildAddressString()
    this.updateAddress(address)
  }

  buildAddressString() {
    const street = document.querySelector('[data-address-field="street"]')?.value || ''
    const city = document.querySelector('[data-address-field="city"]')?.value || ''
    const state = document.querySelector('[data-address-field="state"]')?.value || ''
    const zip = document.querySelector('[data-address-field="zip"]')?.value || ''
    const country = document.querySelector('[data-address-field="country"]')?.value || ''

    return [street, city, state, zip, country].filter(part => part.length > 0).join(', ')
  }

  showMap() {
    if (this.mapElement) {
      const mapPreview = this.mapElement.closest('.map-preview')
      if (mapPreview) {
        mapPreview.classList.remove('hide')
        // Trigger resize to ensure map renders correctly
        window.setTimeout(() => {
          window.dispatchEvent(new Event('resize'))
          if (this.map) {
            google.maps.event.trigger(this.map, 'resize')
          }
        }, 100)
      }
    }
  }

  hideMap() {
    if (this.mapElement) {
      this.mapElement.closest('.map-preview')?.classList.add('hide')
    }
  }

  updateAddress(address) {
    if (!address?.length) return
    if (!this.geocoder) {
      this.pendingAddress = address
      return
    }

    // Clear any pending geocode request
    if (this.geocodeTimeout) {
      clearTimeout(this.geocodeTimeout)
    }

    // Debounce the geocoding request by 500ms
    this.geocodeTimeout = setTimeout(() => {
      this.showMap()
      this.geocoder.geocode({ 'address': address }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
          const location = results[0].geometry.location
          console.log('Geocoding result:', { address, location, status })
          this.initializeMap(location)
        } else {
          console.error('Geocoding failed:', { address, status, results })
          this.hideMap()
          const statusElement = document.getElementById('venue_map_status')
          if (statusElement) {
            statusElement.innerHTML = 'Could not find address: ' + status
          }
        }
      })
    }, 500)
  }

  initializeMap(latlng) {
    const mapElement = document.getElementById(this.mapId)
    if (!mapElement) return

    // Validate latlng is a proper LatLng object or convert it
    let validLatLng
    if (latlng && typeof latlng.lat === 'function' && typeof latlng.lng === 'function') {
      // It's a google.maps.LatLng object
      validLatLng = latlng
    } else if (latlng && typeof latlng.lat === 'number' && typeof latlng.lng === 'number') {
      // It's a LatLngLiteral object
      validLatLng = new google.maps.LatLng(latlng.lat, latlng.lng)
    } else {
      console.error('Invalid latlng provided to initializeMap:', latlng)
      this.hideMap()
      return
    }

    if (!this.map) {
      this.map = new google.maps.Map(mapElement, {
        zoom: 15,
        center: validLatLng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        draggable: false,
        zoomControl: false,
        scrollwheel: false,
        disableDoubleClickZoom: true
      })

      // Add a static marker using map center circle with a more visible design
      const circle = new google.maps.Circle({
        strokeColor: "#DB4437",  // Google Maps Red
        strokeOpacity: 1.0,
        strokeWeight: 2,
        fillColor: "#DB4437",
        fillOpacity: 1.0,
        map: this.map,
        center: validLatLng,
        radius: 8  // Slightly larger for better visibility
      })
    } else {
      this.map.setCenter(validLatLng)
    }
  }

  destroy() {
    if (this.geocodeTimeout) {
      clearTimeout(this.geocodeTimeout)
      this.geocodeTimeout = null
    }
    if (this.map) {
      this.map = null
    }
  }
}

window.VenueMap = VenueMap
export default VenueMap
